import apiClient from "../api/apiClient";

export const getInvoiceReport = async (payload) => {
    const res = await apiClient.post("/admin/invoice/report", payload);
    return res.data;
};

export const getGroupInvoiceReport = async (payload) => {
    const res = await apiClient.post("/invoices/group", payload);
    return res.data;
};

export const fetchParentInvoices = async () => {
    const res = await apiClient.get("/invoices/parent");
    return res.data;
};

export const downloadInvoice = async (invoiceId) => {
    const res = await apiClient.get(`/invoices/download/invoice/${invoiceId}`);
    return res.data;
};

export const downloadReceipt = async (invoiceId) => {
    const res = await apiClient.get(`/invoices/download/receipt/${invoiceId}`);
    return res.data;
};

export const fetchPaymentHistory = async () => {
    const res = await apiClient.get("/invoices/payment-history");
    return res.data;
};

export const fetchPendingApprovals = async () => {
    const res = await apiClient.get("/payments/pending-approval");
    return res.data;
};

export const approveRejectPayment = async (payload) => {
    const res = await apiClient.post("/payments/approve-reject-payment", payload);
    return res.data;
};
